export default __webpack_public_path__ + "dc49cef7f6cefcd4084afded952e7aae.svg";